import { Dock } from "shared/api/types";

export function getDockShortAddress(dock: Dock): string {
  return `${dock.cityObject?.name || dock.city}, ${dock.state}`;
}

export function geDockFullAddress(dock: Dock): string {
  return `${dock.name}, ${dock.address}, ${dock.state} ${dock.zipCode}, USA`;
}
